import { formatToDevanagariStyle, formatWeek } from "@/utilities/helper"

export const columns = [
  {
    accessorKey: "week_label",
    header: "Sale Week",
  },
  {
    accessorKey: "total_sales",
    header: "Total Sales",
    cell: ({ row }) =>
      `Rs. ${formatToDevanagariStyle(row.original.total_sales)}`,
  },
  { accessorKey: "total_orders", header: "Total Orders" },
]
